import React, {useEffect, useState} from 'react'
import {useHistory} from "react-router-dom";
import Button from "../base/button/Button";
import Text from "../base/text/Text";
import Toolbar from "../base/toolbar/Toolbar";
import Loader from "../base/loader/Loader";
import LobbyItem from "./lobbyitem/LobbyItem";
import '../base/Theme.css';
import './Lobby.css';
import firebase from "firebase";
import "firebase/firestore"
import {Players, Tables} from "../../firebase/Collections";
import {mapToPlayer, mapToTable} from "../../firebase/Mappers";
import {showError} from "../base/toaster/CustomToaster";
import {formatValue} from "../../utils/Formatter";
import {DONATE_ADDRESS, ISSUES_URL, ROADMAP_URL} from "../../constants/Constants";
import Space from "../base/space/Space";


function Lobby() {
    const history = useHistory();
    const [player, setPlayer] = useState(null);
    const [tables, setTables] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        watchAuth();
        watchTables();
    }, [])

    const watchAuth = () => {
        firebase.auth().onAuthStateChanged(function (user) {
            if (user) {
                watchPlayer(user);
            }
        });
    }

    const watchPlayer = (user) => {
        setLoading(true);
        firebase.firestore()
            .collection(Players.NAME)
            .doc(user.uid)
            .onSnapshot((doc) => {
                const player = mapToPlayer(doc);
                setPlayer(player);
                setLoading(false);
            });
    }

    const watchTables = () => {
        firebase
            .firestore()
            .collection(Tables.NAME)
            .onSnapshot((snapshot) => {
                const tables = [];
                snapshot.forEach((doc) => {
                    const table = mapToTable(doc);
                    tables.push(table);
                });
                tables.sort((t1, t2) => (t1.smallBlind - t2.smallBlind));
                setTables(tables);
            })
    }

    const onDepositClick = () => {
        history.push("/deposit");
    }

    const onWithdrawClick = () => {
        history.push("/withdraw");
    }

    const onTableClick = (table) => {
        history.push("/table/" + table.id);
    }

    const onLoginClick = () => {
        history.push("/login");
    }

    const onRoadmapClick = () => {
        window.open(ROADMAP_URL, "_blank")
    }
    const onIssuesClick = () => {
        window.open(ISSUES_URL, "_blank")
    }

    const onLogoutClick = async () => {
        setLoading(true);
        try {
            await firebase.auth().signOut()
            setPlayer(null)
        } catch (e) {
            showError("Failed to logout.")
        }
        setLoading(false)
    }

    const onProfileClick = () => {
        history.push("/profile");
    }

    const buildAuthButton = () => {
        if (player) {
            return (<Button style="TransparentButton"
                            textStyle={"TextAlignRight"}
                            onClick={onLogoutClick}
                            text={"Logout"}/>)
        } else {
            return (
                <Button style="TransparentButton"
                        textStyle={"TextAlignRight"}
                        onClick={onLoginClick}
                        text={"Login"}/>)
        }
    }

    const buildProfileButton = () => {
        if (player) {
            return (<Button style="TransparentButton"
                            textStyle={"TextAlignLeft"}
                            onClick={onProfileClick}
                            text={player?.name}/>)
        } else {
            return null;
        }
    }

    const buildPlayerData = () => {
        if (!player) return null;

        return (<div className="LobbyBar">
            <Button style="LobbyBarButton" text={formatValue(player?.money)}/>
            <div className="LobbyBarRight">
                <Button style="LobbyBarButton" onClick={onDepositClick} text={"Deposit"}/>
                <Space space={8}/>
                <Button style="LobbyBarButton" onClick={onWithdrawClick} text={"Withdraw"}/>
            </div>
        </div>)
    }

    const buildTableItems = () => {
        return <div className={"TableItems"}>{(() => {
            return tables?.map((table) => {
                const highlight = table.id === player?.tableId;
                return <LobbyItem table={table} onClick={onTableClick} highlight={highlight}/>
            })
        })()}
        </div>
    }

    const buildDonate = () => {
        return (
            <div className="LobbyDonateContainer">
                <Text style="LobbyDonateText" text={"Support development with donation"}/>
                <Text style="LobbyDonateAddress" text={DONATE_ADDRESS}/>
            </div>
        );
    }

    const buildRoadmap = () => {
        return (
            <Button style={"LinkButton"} text={"Roadmap"} onClick={onRoadmapClick}/>
        );
    }

    const buildIssues = () => {
        return (
            <Button style={"LinkButton"} text={"Report an issue"} onClick={onIssuesClick}/>
        );
    }

    if (loading || !tables) {
        return <div className={"Root"}><Loader/></div>
    }

    return (
        <div className="Root">
            <div className="Content">
                <Toolbar leftButton={buildProfileButton()} rightButton={buildAuthButton()} title={"Lobby"}/>
                {buildPlayerData()}
                {buildTableItems()}
                {buildDonate()}
                {buildRoadmap()}
                {buildIssues()}
            </div>
        </div>
    );
}

export default Lobby;
